export default __webpack_public_path__ + "static/media/viber.62621a7a.svg";